module.exports = __webpack_public_path__ + "static/media/logos.57e848fa.png";